import {presentedFields, type ToolPresentation} from "../toolPresentation";

/** Script-owned copy, field order, and value labels for creation reviews. */
export function presentPhoneScriptCreation(presentation: ToolPresentation, input: unknown, t: (key: string) => string): ToolPresentation {
   const fields = presentedFields(input, presentation.fields);
   const names = ["name", "agentName", "direction", "greeting", "goodbye", "useCaseAssociations"];
   const settings = ["greetingMode", "giveSurvey", "voiceProvider", "voice", "voicemail", "faqs", "postCallScripts", "toolAssociations"];
   const property = (path: string[]) => path.length === 1 ? path[0] : path.length === 2 && path[0] === "body" ? path[1] : "";
   return {...presentation, icon: "document",
      title: {text: t("toolApproval.createScript.title")},
      approveLabel: {text: t("toolApproval.createScript.approve")},
      description: {text: t("toolApproval.createScript.description")},
      fields: [...fields].sort((a, b) => {
         const rank = (path: string[]) => {const index = [...names, ...settings].indexOf(property(path)); return index < 0 ? names.length + settings.length : index;};
         return rank(a.path) - rank(b.path);
      }).map(({value: _value, ...field}) => {
         const name = property(field.path);
         const path = field.path[0] === "body" ? field.path.slice(1) : field.path;
         if (path.length === 2 && path[0] === "knowledgeBase" && ["documentIds", "documentTags"].includes(path[1]))
            return {...field, label: {text: t(`toolApproval.createScript.${path[1]}`)}};
         if (!names.includes(name) && !settings.includes(name)) return field;
         return {...field, label: {text: t(`toolApproval.createScript.${name}`)},
            ...(name === "name" ? {emphasis: "primary" as const} : {}),
            ...(["greeting", "goodbye"].includes(name) ? {format: "multiline" as const} : {}),
            ...(name === "greetingMode" ? {choices: [{value: "static", label: {text: t("toolApproval.createScript.staticGreeting")}}]} : {}),
            ...(name === "giveSurvey" ? {choices: [true, false].map(value => ({value, label: {text: t(`toolApproval.createScript.${value ? "enabled" : "disabled"}`)}}))} : {}),
            ...(name === "voiceProvider" ? {choices: [{value: "elevenlabs", label: {text: "ElevenLabs"}}]} : {}),
         };
      }),
   };
}
